<template>
  <div id="articles" ref="articles" class="articles-wrapper" v-view="viewHandler">

    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide data-hash="article1"><Article /></swiper-slide>
      <swiper-slide data-hash="article2"><Article2 /></swiper-slide>
      <swiper-slide data-hash="article3"><Article3 /></swiper-slide>
      <swiper-slide data-hash="article4"><Article4 /></swiper-slide>
      <swiper-slide data-hash="article5"><Article5 /></swiper-slide>
      <swiper-slide data-hash="article6"><Article6 /></swiper-slide>
      <swiper-slide data-hash="article7"><Article7 /></swiper-slide>
    </swiper>

    <div v-if="!isSwiperReady" class="articles-wrapper__overlay"></div>


    <div :class="{'is-visible': isSwiperReady}" class="mobile-hidden article__next">
      <svg viewBox="0 0 52 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 13C0.89543 13 0 13.8954 0 15C0 16.1046 0.89543 17 2 17V13ZM51.4142 16.4142C52.1953 15.6332 52.1953 14.3668 51.4142 13.5858L38.6863 0.857864C37.9052 0.0768156 36.6389 0.0768156 35.8579 0.857864C35.0768 1.63891 35.0768 2.90524 35.8579 3.68629L47.1716 15L35.8579 26.3137C35.0768 27.0948 35.0768 28.3611 35.8579 29.1421C36.6389 29.9232 37.9052 29.9232 38.6863 29.1421L51.4142 16.4142ZM2 17H50V13H2V17Z" fill="white"/>
      </svg>
    </div>
    <div :class="{'is-visible': isSwiperReady}" class="mobile-hidden article__prev">
      <svg viewBox="0 0 52 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M50 13C51.1046 13 52 13.8954 52 15C52 16.1046 51.1046 17 50 17V13ZM0.585785 16.4142C-0.195263 15.6332 -0.195263 14.3668 0.585785 13.5858L13.3137 0.857864C14.0948 0.0768156 15.3611 0.0768156 16.1421 0.857864C16.9232 1.63891 16.9232 2.90524 16.1421 3.68629L4.82843 15L16.1421 26.3137C16.9232 27.0948 16.9232 28.3611 16.1421 29.1421C15.3611 29.9232 14.0948 29.9232 13.3137 29.1421L0.585785 16.4142ZM50 17H2V13H50V17Z" fill="white"/>
      </svg>
    </div>

    <div class="article__next-mob">
      <svg viewBox="0 0 52 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 13C0.89543 13 0 13.8954 0 15C0 16.1046 0.89543 17 2 17V13ZM51.4142 16.4142C52.1953 15.6332 52.1953 14.3668 51.4142 13.5858L38.6863 0.857864C37.9052 0.0768156 36.6389 0.0768156 35.8579 0.857864C35.0768 1.63891 35.0768 2.90524 35.8579 3.68629L47.1716 15L35.8579 26.3137C35.0768 27.0948 35.0768 28.3611 35.8579 29.1421C36.6389 29.9232 37.9052 29.9232 38.6863 29.1421L51.4142 16.4142ZM2 17H50V13H2V17Z" fill="white"/>
      </svg>
    </div>
    <div class="article__prev-mob">
      <svg viewBox="0 0 52 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M50 13C51.1046 13 52 13.8954 52 15C52 16.1046 51.1046 17 50 17V13ZM0.585785 16.4142C-0.195263 15.6332 -0.195263 14.3668 0.585785 13.5858L13.3137 0.857864C14.0948 0.0768156 15.3611 0.0768156 16.1421 0.857864C16.9232 1.63891 16.9232 2.90524 16.1421 3.68629L4.82843 15L16.1421 26.3137C16.9232 27.0948 16.9232 28.3611 16.1421 29.1421C15.3611 29.9232 14.0948 29.9232 13.3137 29.1421L0.585785 16.4142ZM50 17H2V13H50V17Z" fill="white"/>
      </svg>
    </div>

    <div class="article__pages">
      {{ slideIndex }} <span class="is-gray">/</span> <span class="is-dark">7</span>
    </div>
  </div>
</template>

<script>
  import './articles-wrapper.scss'
  import Article from "../Article/Article";
  import Article2 from "../Article/Article2";
  import Article3 from "../Article/Article3";
  import Article4 from "../Article/Article4";
  import Article5 from "../Article/Article5";
  import Article6 from "../Article/Article6";
  import Article7 from "../Article/Article7";

  export default {
    name: "ArticlesWrapper",
    components: {Article7, Article6, Article5, Article4, Article3, Article2, Article},
    data() {
      return {
        swiperOptions: {
          mousewheel: true,
          hashNavigation: {
            watchState: true,
          },

          breakpoints: {
            320: {
              mousewheel: false,
              navigation: {
                nextEl: '.article__next-mob',
                prevEl: '.article__prev-mob'
              },
              autoHeight: true,
            },
            1025: {
              navigation: {
                nextEl: '.article__next',
                prevEl: '.article__prev'
              },
            }
          },
          on: {
            slideChange() {
              setTimeout(()=>{
                let str = location.hash
                let cslide = 'chapter_' + parseInt(str.match(/\d+/))

                window.gtag('event', 'pageView', {
                  'event_category': 'chapter_change',
                  'event_label': cslide
                });
                window.ym(86974684, 'reachGoal', 'chapter_change/pageView' + cslide);
              }, 500)
            },
          },
        },
        currentArticle: 1,
        isArtclesIntoView: false,
        isScrolled: false,
        isSwiperReady: false,
        slideIndex: 1,
        isGASent: false,
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      },
    },
    methods: {
      viewHandler(e) {
        this.isArtclesIntoView = e.percentInView > 0.8

        this.isSwiperReady = e.percentInView >= 0.99

        if(this.isGASent) {
          this.isGASent = true

          window.gtag('event', 'scroll', {
            'event_category': 'main_scroll_down',
            'event_label': 'intro'
          });
          window.ym(86974684, 'reachGoal', 'main_scroll_down/scroll/intro');
        }
      },

    },
    mounted() {
      setInterval(() => {
        this.slideIndex = this.swiper.activeIndex + 1
      }, 250)
    }
  }
</script>

<style scoped>

</style>
